import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../../contexts/AuthContext";
import { formatApiError } from "../../lib/api";
import SEO from "../../components/SEO";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("admin@noonfoto.com");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4" data-testid="admin-login-page">
      <SEO admin title="Sign in" />
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="font-display text-2xl font-semibold tracking-tight">Noon Foto</div>
          <div className="text-[10px] uppercase tracking-[0.3em] text-zinc-500 mt-2">Admin Panel</div>
        </div>
        <form onSubmit={submit} className="border border-white/10 bg-[#0A0A0A] p-8">
          <div className="text-xs uppercase tracking-[0.3em] text-zinc-500 mb-6">Sign in</div>
          <div className="space-y-4">
            <input
              required
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="login-email-input"
            />
            <input
              required
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#141414] border border-white/10 px-4 py-2.5 text-sm focus:outline-none focus:border-white/30"
              data-testid="login-password-input"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="brand-btn w-full mt-6 py-3 text-sm uppercase tracking-[0.2em] disabled:opacity-50"
            data-testid="login-submit-btn"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
